// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 14-May-2019 10:00:00 AM
// File Created Date      : 14-May-2019 10:00:00 AM
import Vue from 'vue';
import { http } from '@/shared/https';
import Axios from 'axios';

export default {
    namespaced: true,
    //#. An object containing the data
    state: { 
        workflowImplemented: false,
        comments: false,
        tooltipContainer: false,
        workflowStepId: 'WorkFlowStatusId',
        workflowComments: 'Comments',
        currentStep: 1,
        left: 0,
        top: 0,
        index: 0,
        log: [],
        logItem: [],
        permittedOptions: [],
        optionsList: [],
        pagination: {
            page: 1,
            itemsPerPage: 1
        },
        actions:
        {
            updateAction: 'workflow/getWorkFlowStep',
        },
        fields: {
            StepName: {
                type: "TextInput",
                title: "Step Name",
                value: 'StepName'
            },
            UpdatedBy: {
                type: "TextInput",
                title: "Updated By",
                value: 'UpdatedBy'
            },
            UpdatedOn: {
                type: "TextInput",
                title: "Updated On",
                value: 'UpdatedOn'
            },
            Comments: {
                type: "TextInput",
                title: "Comments",
                value: 'Comments'
            }
        }
    },

    //#. Used to access data from the state tree of the store
    getters: {
    },

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) {
        },

        //#. fn_formCancel function
        formCancel(state, payload) {
        },

        //#. fn_recordCreated function
        recordCreated(state, payload) {
        },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) {  
        },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) {
        },

        //#. fn_loadingRecords function
        loadingRecords(state, payload) {
        },
         
        //#. fn_recordsLoaded function
        recordsLoaded(state, payload) {
        }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },

        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
         //#. loadingRecords event will be fired
         loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },
       
        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        },

        //#. getWorkFlowStep event will be fired
        getWorkFlowStep: ({ commit, rootState }, payload) => {
            //#. Get current workflow step id..
            let stepId = payload.context.editedItem[payload.context.workflow.workflowStepId]; //.Value;

            return http.get(payload.context.actions.createAction + '/GetWorkFlowStep/' + payload.context.controllerName + '/true/' + stepId + '/' + payload.context.dashboard.componentId).then(record => {
                //#. Render header, boody and footer information based on the settings
                if (record.data.Result == 'OK') {
                    //#. Remove component in the DOM
                    payload.context.workflow.workflowImplemented = false;
                    payload.context.workflow.comments = false;
                    payload.context.workflow.permittedOptions = record.data.Record;
                    payload.context.workflow.log = record.data.List.Result.Value.Log;

                    Vue.nextTick(() => {
                        //#. Add the component back in
                        payload.context.workflow.workflowImplemented = true;
                    });

                } else {
                    commit('_logError', { payload: payload, message: record.data.Message, action: 'load >' });
                }
            });
        }
    }
}